export default __webpack_public_path__ + "static/media/selectedgear.537d0692.svg";